import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import Introduction from "./PresentationStep/Introduction.jsx"
import Presentation from "./PresentationStep/Presentation.jsx"

const PAGES = {
  FIRST: 'introduction',
  SECOND: 'presentation'
}
class PresentationStep extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      currentPage: PAGES.FIRST
    }
  }

  render() {
    return (this.state.currentPage === PAGES.FIRST)
      ? <Introduction
        currentUser={this.props.currentUser}
        freelance={this.props.freelance}
        submit={this.props.submit}
        history={this.props.history}
        nextPage={() => this.setState({currentPage: PAGES.SECOND})} />
      : <Presentation
        currentUser={this.props.currentUser}
        freelance={this.props.freelance}
        submit={this.props.submit}
        prevPage={() => this.setState({currentPage: PAGES.FIRST})} />
  }
}

export default PresentationStep
